import { Richtwert } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/Richtwert';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function ArbeitszeitkontoStundenlohn() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.label',
        )}
      </span>
      <span className="text-neutrals-900 font-semibold">
        {!data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze
          ? t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenze.options.false',
            )
          : data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEuro
            ? `${data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEuro} ${t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEuro.suffix',
              )}`
            : `${data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeStunden} ${t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeStunden.suffix',
              )}`}
      </span>
      {!data.bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenze && (
        <Richtwert />
      )}
    </div>
  );
}
